
import { computed, defineComponent, onMounted, reactive } from 'vue';
import ModalMensagemDorape from "./components/ModalMensagemDorape.vue";
import NavBar from './components/NavBar.vue';
import Footer from './components/Footer.vue';
import Mensagem from '@/hooks/mensagem';
import { store } from './store/index';
import { RouterView } from 'vue-router';
import moment from 'moment';
import services from './services';
import { TipoMensagem } from './consts/consts';
import mensagem from '@/hooks/mensagem';

export default defineComponent({
  name: "App",

  setup() {
    const state = reactive({
      // tamanhos:Array(800,1024,1152,1280,1440,1600,1680,1776,1920)
      tema: String(),
    });

    const mensagens = computed(() => {
      return store.getters.getMensagens;
    });

    const modalMensagemResult = (pModalResult: string, pId: string) => {
      const msg = Mensagem();
      msg.ExcluirMensagem(pId);
    };

    const maiusculo = (pObj: any, pParam: string) => {
      if (pObj[pParam].trim() != "" || pObj[pParam] == null) {
        return pObj[pParam].toUpperCase();
      } else if (pObj[pParam].trim() === "") {
        return null;
      }
    };

    const retornaDataBR = (pData: any) => {
      return moment(pData).format("DD/MM/YYYY");
    };

    const retornaDataUSA = (pData: any) => {
      return moment(pData).format("MM/DD/YYYY");
    };

    const retornaIdVDatePicker = (pData: any) => {
      return `id-${moment(pData).format("YYYY-MM-DD")}`;
    };

    const retornaPossuiPermissao = (pPermissao: string) => {
      let permissoes = sessionStorage.getItem('permissoes');
      let aux = true;
      if (permissoes) {
        JSON.parse(permissoes).forEach((l: string) => {
          if (l === pPermissao.toUpperCase()) {
            aux = false;
          }
        });
      }
      return aux;
    };

    function trocarTema(tema: string) {
      state.tema = tema;
    }

    const tamanho = () => {
      setInterval(() => {
        // (window.innerWidth <= 992) ? state.telaPequena = true : state.telaPequena = false;
        return (window.innerWidth <= 1023) ? true : false;
      }, 100);
    };

    // const tamanho = computed(() => {
    //   return (window.innerWidth <= 1023) ? true : false;
    // });

    return {
      state,
      mensagens,
      modalMensagemResult,
      maiusculo,
      retornaPossuiPermissao,
      retornaDataBR,
      retornaDataUSA,
      retornaIdVDatePicker,
      tamanho,
      trocarTema,
    };
  },

  components: {
    ModalMensagemDorape,
    NavBar,
    Footer,
  },
});
